module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/parts-v2-2ad868a104133286c5e42c3dc6e6bc53.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/parts-v2.svg
// module id = AzPM
// module chunks = 1 3 10 12 18